export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificação AML"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite um endereço e selecione uma blockchain — realizaremos uma triagem rápida."])}
}